import Loadable from "@loadable/component";

const OrderSuccess = Loadable(
  () => import(/* webpackChunkName: "order_success_page" */ "./orderSuccess")
);

export default OrderSuccess;
